export const FILE_INPUT_TEST_ID = "file-input";
